module.exports = __webpack_public_path__ + "static/img/uc.452b8de5.png";